import { render } from "./ProductPanel.vue?vue&type=template&id=484e37df"
import script from "./ProductPanel.vue?vue&type=script&lang=js"
export * from "./ProductPanel.vue?vue&type=script&lang=js"

import "./ProductPanel.vue?vue&type=style&index=0&id=484e37df&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__